import AbstractComponent from "./abstract-component";

const createTemplate = () => {
  return (
    `<div class="cookie">
      <div class="cookie__container">
        <div class="cookie__wrap">
          <div class="cookie__textWrap">
            <p class="cookie__text">Мы используем файлы cookie<span class="cookie__text--mobileHide"> для вашего удобства. 
            Продолжая пользоваться сайтом, вы соглашаетесь с политикой использования cookie</span>.</p>
            <button class="cookie__moreButton" type="button">Подробнее</button>
          </div>
          <button class="cookie__agreeButton" type="button">Я согласен</button>
        </div>
      </div>
    </div>`
  );
};

export default class CookieComponent extends AbstractComponent {
  getTemplate() {
    return createTemplate();
  }

  setMoreButtonClickHandler(handler) {
    this.getElement().querySelector(`.cookie__moreButton`)
    .addEventListener(`click`, handler);
  }

  setAgreeButtonClickHandler(handler) {
    this.getElement().querySelector(`.cookie__agreeButton`)
    .addEventListener(`click`, handler);
  }
}
